<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "00b83b6d-1770-11eb-8116-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      name: [],
      count: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.name,
            datasets: [{
              label: this.chart_description,
              data: this.count,
              maxBarThickness: 800
            }]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во неисправностей'
                },
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              },
              legend: {
                display: false
              },
            }
          }
        });
      }
    },
    update_data: function () {
      this.name = []
      this.count = []

      for (let i =0; i < this.chart.report_data.length; i++) {
        this.count.push(this.chart.report_data[i]["КоличествоНеисправностей"])
        this.name.push(this.chart.report_data[i]["Вид"])
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  },
}
</script>